var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLivespotting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-4.854 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0085E9",
    d: "M0 2.293L4.078 12 .001 21.707 9.706 12z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0085E9",
    d: "M2.294 0L0 2.293 9.706 12 .001 21.707 2.294 24l11.999-12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivespotting);
export default __webpack_public_path__ + "static/media/livespotting.a4a3b5b36e3f335220c11aa9b9b107c7.svg";
export { ForwardRef as ReactComponent };